// extracted by mini-css-extract-plugin
export default {"root":"RKmPINGfOR","root_paragraphNoMargin":"Bz6WofDwbh","root_imageNoMaxWidth":"LnQRz4U0KT","root_imageVerticalAlignBottom":"_8fg8sf2QEi","root_applySafariFix":"cjhELHlplP"};